import list from './list';
import customer from './customer';
import invoiceList from './invoice-list';
import documentList from './document-list';
import settlementList from './settlement-list';
import document from './document';
import settlement from './settlement';
import create from './create';
import update from './update';
import show from './show';
import del from './delete';
import invoiceToDeduction from './invoice-to-deduction';
import invoiceToRefund from './invoice-to-refund';

export default {
  namespaced: true,
  modules: {
    list,
    create,
    update,
    show,
    del,
    customer,
    invoiceList,
    documentList,
    document,
    settlementList,
    settlement,
    invoiceToDeduction,
    invoiceToRefund
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/agreement/index.js